import React, { useState, useEffect, useRef } from "react";
import defaultImg from "../../assets/WidgetMaker/Brocken_Image.svg";
import pdfIcon from "../../assets/pdf-svg-icon.svg";
import Image from "antd/lib/image";
import { Modal, Progress, Tooltip } from "antd";
import CarouselWidgetMaker from "./Carousel";
import VideoPreview from "./VideoPreview";
import moment from "moment";
import PostCardDetails from "./PostCardDetails";
import {
  getTextDirection,
  getTextWithWrapHtml,
  getunMaskedText,
  kFormatter,
} from "../../redux/constants";
import { useDispatch, useSelector } from "react-redux";
import EyeWhiteIcon from "../../assets/eye_icon_white.svg";
import PostTextComponent from "./PostTextComponent";
import Rate from "antd/lib/rate";
import tiredEmoji from "../../assets/icons/Tired.png";
import frowningFace from "../../assets/icons/Frowning-Face.png";
import neutralFace from "../../assets/icons/Neutral-Face.png";
import smilingFaceWithSmilingEyes from "../../assets/icons/Smiling-Face-With-Smiling-Eyes.png";
import smilingFaceWithHeartEyes from "../../assets/icons/Smiling-Face-With-Heart-Eyes.png";
import { useIsOverflow } from "../shared/Hooks/useIsOverflow";
import { ElementTypeEnum, NPS_OPTIONS } from "../../redux/constants/enums";

const PostAttachment = ({
  el,
  i,
  PdfDownloadStatus,
  PptGeneratingStatus,
  data,
  isPreviewState,
  postText,
  deepDive,
  trendView,
  isCommandCenterScreen,
  custom_card_settings,
  isTrandsView = false,
  setAutoPlay,
  qrChannel,
  pantipChannel,
  section_index,
  widget_index,
  isTwitterTrendScreen,
  highlightWord,
  isDeepDiveDashboardView = false,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  const unMaskedInfo = useSelector((state) => state.ApiCall.unMaskedInfo);
  const unMaskedInfoId = useSelector((state) => state.ApiCall.unMaskedInfoId);
  const [finalPostText, setFinalPostText] = useState("");
  const surveyFieldContainer = useRef();
  const [isSurveyFieldsAreOverflowed, setIsSurveyFieldsAreOverflowed] =
    useState(false);
  const isSurveyFieldsAreOverflowedHook = useIsOverflow(
    surveyFieldContainer,
    (isOverflowFromCallback) => {
      setIsSurveyFieldsAreOverflowed(isOverflowFromCallback);
    }
  );
  const [visible, setVisible] = useState({ id: null, value: false });
  const isDashboardScheduleModal = useSelector(
    (state) => state?.ApiCall?.is_dashboard_schedule_modal
  );
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const [isModalLoader, setIsModalLoader] = useState(false);
  const [modalData, setIsModalData] = useState(null);
  const [isImage, setIsImage] = useState({});

  const [previewImgUrl, setPreviewImgUrl] = useState("");
  const [closeImagePreview, setCloseImagePreview] = useState(false);

  const [videoPreview, setVideoPreview] = useState();
  const [isValidUrlFlag, setIsValidUrlFlag] = useState(null);

  const [isNewData, setIsNewData] = useState(false);
  const [previousValue, setPreviousValue] = useState(null);

  useEffect(() => {
    if (el?.value !== previousValue) {
      animateUpdate(el?.value);
      setVideoPreview(videoPreview);
      setIsVideoModalOpen(isVideoModalOpen);
      setPreviewImgUrl(previewImgUrl);
      setCloseImagePreview(closeImagePreview);
    }
  }, [el?.value, previousValue]);

  useEffect(() => {
    if (unMaskedInfo !== null) {
      setTimeout(() => {
        for (let i = 0; i < unMaskedInfoId?.length; i++) {
          if (
            unMaskedInfoId?.[i]?.TagID === el?.TagID ||
            unMaskedInfoId?.[i]?.TagID === el?.tagid
          ) {
            setFinalPostText(unMaskedInfoId?.[i]?.unmaskedPostText);
            break;
          }
        }
      }, 150);
    }
  }, [unMaskedInfo, unMaskedInfoId]);

  const animateUpdate = (newValue) => {
    setIsNewData(true);
    setTimeout(() => {
      setPreviousValue(newValue);
      setIsNewData(false);
    }, 400);
  };

  const showModal = (data) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    // To Stop Carousel in Brand Post Screen
    if (
      authParams?.screen_id === "000-000-562" &&
      !trendView &&
      !isDeepDiveDashboardView
    ) {
      setAutoPlay(false);
    }
    const ThreeDGlobalPage =
      authParams?.screen_id === "000-000-555" ||
      authParams?.screen_id === "000-000-551" ||
      authParams?.screen_id === "000-000-557" ||
      authParams?.screen_id === "000-000-564"
        ? true
        : false;
    const updateData = ThreeDGlobalPage
      ? {
          ...data,
          isModalOpen: !isModalOpen,
        }
      : data;
    setIsModalLoader(true);
    setIsModalOpen(true);
    setIsModalData(updateData);
  };

  const onImageError = (e, id) => {
    if (e?.type === "error") {
      setIsImage({
        ...isImage,
        [id]: true,
      });
    } else {
      setIsImage({
        ...isImage,
        [id]: false,
      });
    }
    return (e.target.src = defaultImg);
  };

  const isScontentLinkExpire = (mediaUrl, channelType) => {
    let isExpired = false;
    try {
      if (
        mediaUrl &&
        mediaUrl.indexOf("s3.amazonaws") == -1 &&
        mediaUrl.indexOf("images.locobuzz.com") == -1
      ) {
        const tokens = mediaUrl.split("&");
        const HexDecimalCode = tokens.filter((x) => x.includes("oe="));
        if (
          HexDecimalCode != null &&
          HexDecimalCode.length > 0 &&
          HexDecimalCode[0].startsWith("oe=")
        ) {
          let DecimalEpoch = 0;
          if (HexDecimalCode.length > 0) {
            const HexDecimalTime = HexDecimalCode[0].replace("oe=", "");
            DecimalEpoch = parseInt(HexDecimalTime, 16);
          }
          // DateTimeOffset.Now.ToUnixTimeSeconds()
          if (moment().unix() > DecimalEpoch && DecimalEpoch > 0) {
            isExpired = true;
          }
        }
      }
    } catch (exception) {
      return false;
    }

    return isExpired;
  };

  const idPresentFlag =
    unMaskedInfo?.tagids?.includes(el?.TagID) ||
    unMaskedInfo?.tagids?.includes(el?.tagid);
  const handleVideoPreview = (imgUrl) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    setIsVideoModalOpen(true);
    setVideoPreview(imgUrl?.MediaUrl);

    let isValidUrlFlag = isScontentLinkExpire(imgUrl?.MediaUrl, 1);
    setIsValidUrlFlag(isValidUrlFlag);
  };

  const onClickImagePreview = (imgUrl) => {
    setPreviewImgUrl(imgUrl);
    setCloseImagePreview(true);
  };

  const handleCloseVideoModalClose = (value) => {
    setIsVideoModalOpen(value);
    setVideoPreview("");
  };

  const handleCloseImagePerview = () => {
    setPreviewImgUrl("");
    setCloseImagePreview(false);
    setIsVideoModalOpen(false);
    setVideoPreview("");
  };

  const commandCenterInfluencersPageId =
    authParams?.screen_id === "000-000-553" && !isDeepDiveDashboardView
      ? true
      : false;

  // if isCommandCenterScreen is true directly assign ppt view
  PptGeneratingStatus = isDeepDiveDashboardView
    ? false
    : authParams?.screen_id === "000-000-550" ||
      authParams?.screen_id === "000-000-551" ||
      authParams?.screen_id === "000-000-552" ||
      authParams?.screen_id === "000-000-553" ||
      authParams?.screen_id === "000-000-554" ||
      authParams?.screen_id === "000-000-555" ||
      authParams?.screen_id === "000-000-556" ||
      authParams?.screen_id === "000-000-557" ||
      authParams?.screen_id === "000-000-558" ||
      authParams?.screen_id === "000-000-559" ||
      authParams?.screen_id === "000-000-562" ||
      authParams?.screen_id === "000-000-564"
    ? false
    : isCommandCenterScreen
    ? isCommandCenterScreen
    : PptGeneratingStatus;

  let pollData =
    el?.PollData &&
    el?.PollData !== "" &&
    el?.PollData !== "NA" &&
    el?.PollData?.length
      ? JSON?.parse(el?.PollData)
      : null;

  let isPersonalisedBannerAdded =
    authParams?.screen_id &&
    (personalizationSettingsObj?.CommandCenterLayout === "B1F0" ||
      personalizationSettingsObj?.CommandCenterLayout === "B1F1");
  let brandPostMentionTextHeight = isPersonalisedBannerAdded
    ? "calc(100vh - 56rem)"
    : "calc(100vh - 47rem)";
  let brandPostMentionTextHeightWithAttachment = "calc(50vh - 32.5rem)";
  let brandPostHeight = isPersonalisedBannerAdded
    ? "calc(-17rem + 44vh)"
    : "calc(-15rem + 50vh)";
  // let brandPostHeight = "20rem";
  let textDirection = getTextDirection(finalPostText || postText);
  let textDirectionClass = textDirection === "rtl" ? "text-right-arabic" : "";
  let needToShowScrollableContent =
    (workspace_privileges?.environment === 2 ||
      share_workspace_privileges?.environment === 2) &&
    (el?.PlatformID === 43 || el?.PlatformID === 25);
  return (
    <div
      className={`cardList__body-description ${
        (((authParams?.screen_id === "000-000-551" ||
          authParams?.screen_id === "000-000-555" ||
          authParams?.screen_id === "000-000-556") &&
          !deepDive &&
          !trendView &&
          !isDeepDiveDashboardView) ||
          postText?.length > 34 ||
          PdfDownloadStatus) &&
        authParams?.screen_id !== "000-000-562" &&
        !pollData
          ? "justify-content-between d-flex align-items-start"
          : ""
      } ${
        commandCenterInfluencersPageId ? "d-flex flex-column-reverse" : ""
      } fontSize-12 pl-15 pr-15 ${
        textDirection === "rtl" ? "justify-content-end-arabic" : ""
      }`}
      style={
        authParams?.screen_id === "000-000-562" && !isDeepDiveDashboardView
          ? { whiteSpace: "normal" }
          : pollData
          ? {}
          : PdfDownloadStatus
          ? el?.EmailContentHtml && el?.EmailContentHtml !== "NA"
            ? { minHeight: "0rem" }
            : qrChannel
            ? {
                overflow: "hidden",
              }
            : {}
          : {
              height:
                authParams?.screen_id === "000-000-564" &&
                !isDeepDiveDashboardView
                  ? "20rem"
                  : authParams?.screen_id &&
                    (deepDive || trendView) &&
                    !isDeepDiveDashboardView
                  ? "20rem"
                  : authParams?.screen_id === "000-000-554" &&
                    trendView &&
                    !isDeepDiveDashboardView
                  ? "20rem"
                  : (authParams?.screen_id === "000-000-551" ||
                      authParams?.screen_id === "000-000-556") &&
                    !deepDive &&
                    !trendView &&
                    !isDeepDiveDashboardView
                  ? "10rem"
                  : ((commandCenterInfluencersPageId &&
                      !el.isMenstionCountBlock) ||
                      isTwitterTrendScreen) &&
                    !isDeepDiveDashboardView
                  ? "auto"
                  : el?.PlatformID === 1
                  ? "16.3rem"
                  : "20rem",
              overflow: "hidden",
            }
      }
    >
      {/* Brand Post Screen Attachment and Mentions Text */}
      {qrChannel ? (
        ""
      ) : (
        <>
          {authParams?.screen_id === "000-000-562" &&
          !qrChannel &&
          !isDeepDiveDashboardView ? (
            <>
              {/* Attachment */}
              {el?.Attachment?.length === 1 && !qrChannel ? (
                <div
                  className={
                    commandCenterInfluencersPageId
                      ? "mb-10 w-100 text-center position-relative attachment_image"
                      : "m-0 w-100 text-center position-relative attachment_image"
                  }
                >
                  {el?.Attachment?.length > 0 &&
                    el?.Attachment?.map((imgUrl, index) => {
                      if (
                        imgUrl?.MediaType === "2" ||
                        imgUrl?.MediaType === "4"
                      ) {
                        return imgUrl &&
                          !PdfDownloadStatus &&
                          !PptGeneratingStatus ? (
                          <>
                            <Image
                              src={
                                imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : defaultImg
                              }
                              alt="Preview Group"
                              fallback={defaultImg}
                              preview={
                                personalizationSettingsObj?.isPersonalizationPreviewOpen
                                  ? false
                                  : authParams?.screen_id === "000-000-555"
                                  ? false
                                  : true
                              }
                              style={{
                                height:
                                  authParams?.screen_id === "000-000-562"
                                    ? brandPostHeight
                                    : el?.PlatformID === 1
                                    ? "16.3rem"
                                    : "20rem",
                                objectFit: "cover",
                              }}
                            />
                          </>
                        ) : PdfDownloadStatus || PptGeneratingStatus ? (
                          imgUrl && (
                            <img
                              src={imgUrl?.ThumbUrl}
                              alt="PdfDownloadStatus Attachment Images 3"
                              style={{
                                height:
                                  el?.PlatformID === 1 ? "16.3rem" : "20rem",
                                objectFit: "cover",
                              }}
                              onError={(el) => onImageError(el, i)}
                            />
                          )
                        ) : (
                          ""
                        );
                      } else if (
                        imgUrl?.MediaType === "3" ||
                        imgUrl?.MediaType === "7"
                      ) {
                        return imgUrl &&
                          !PdfDownloadStatus &&
                          !PptGeneratingStatus ? (
                          <>
                            {el?.PlatformID === 2 ||
                            el?.PlatformID === 4 ||
                            el?.PlatformID === 37 ? (
                              <a
                                href={
                                  personalizationSettingsObj?.isPersonalizationPreviewOpen
                                    ? ""
                                    : imgUrl?.MediaUrl
                                    ? imgUrl?.MediaUrl
                                    : ""
                                }
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => {
                                  if (
                                    personalizationSettingsObj?.isPersonalizationPreviewOpen
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              >
                                <div
                                  className="overlay-play-button"
                                  style={{
                                    height:
                                      authParams?.screen_id === "000-000-562"
                                        ? brandPostHeight
                                        : el?.PlatformID === 1
                                        ? "16.3rem"
                                        : "20rem",
                                  }}
                                >
                                  <img
                                    src={
                                      imgUrl?.ThumbUrl
                                        ? imgUrl?.ThumbUrl
                                        : defaultImg
                                    }
                                    alt="Attachment Images"
                                    onError={(el) => onImageError(el, i)}
                                    style={{
                                      width: "100%",
                                      height:
                                        authParams?.screen_id === "000-000-562"
                                          ? brandPostHeight
                                          : el?.PlatformID === 1
                                          ? "16.3rem"
                                          : "20rem",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div className="overlay-play-button__overlay">
                                    <Tooltip
                                      title={
                                        personalizationSettingsObj?.isPersonalizationPreviewOpen
                                          ? "Actions are not allowed while customizing"
                                          : ""
                                      }
                                    >
                                      <div className="overlay-play-button__play">
                                        <i
                                          className="fa fa-play"
                                          style={{
                                            fontSize: "1.2rem",
                                            color: "#fff",
                                          }}
                                        ></i>
                                      </div>
                                    </Tooltip>
                                  </div>
                                </div>
                              </a>
                            ) : el?.PlatformID === 1 ||
                              el?.PlatformID === 3 ||
                              el?.PlatformID === 5 ||
                              el?.PlatformID === 42 ? (
                              <>
                                <div
                                  style={{
                                    height:
                                      authParams?.screen_id === "000-000-562"
                                        ? brandPostHeight
                                        : el?.PlatformID === 1
                                        ? "16.3rem"
                                        : "20rem",
                                  }}
                                  className="overlay-play-button"
                                  onClick={() => handleVideoPreview(imgUrl)}
                                >
                                  <video
                                    width="100%"
                                    style={{
                                      objectFit: "cover",
                                      height:
                                        authParams?.screen_id === "000-000-562"
                                          ? brandPostHeight
                                          : el?.PlatformID === 1
                                          ? "16.3rem"
                                          : "20rem",
                                    }}
                                  >
                                    <source
                                      src={imgUrl?.MediaUrl}
                                      type="video/mp4"
                                    />
                                  </video>
                                  <div className="overlay-play-button__overlay">
                                    <Tooltip
                                      title={
                                        personalizationSettingsObj?.isPersonalizationPreviewOpen
                                          ? "Actions are not allowed while customizing"
                                          : ""
                                      }
                                    >
                                      <div
                                        className={`overlay-play-button__play ${
                                          personalizationSettingsObj?.isPersonalizationPreviewOpen
                                            ? "disabled-cursor"
                                            : ""
                                        }`}
                                      >
                                        <i
                                          className="fa fa-play"
                                          style={{
                                            fontSize: "1.2rem",
                                            color: "#fff",
                                          }}
                                        ></i>
                                      </div>
                                    </Tooltip>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}

                            {/* For Video Preview */}
                            <VideoPreview
                              videoPreview={videoPreview}
                              setIsModalOpen={setIsVideoModalOpen}
                              isModalOpen={isVideoModalOpen}
                              isValidUrlFlag={isValidUrlFlag}
                            />
                          </>
                        ) : PdfDownloadStatus || PptGeneratingStatus ? (
                          imgUrl && (
                            <img
                              src={imgUrl?.ThumbUrl}
                              alt="PdfDownloadStatus Attachment Images 4"
                              style={{
                                height:
                                  el?.PlatformID === 1 ? "16.3rem" : "20rem",
                                objectFit: "cover",
                              }}
                              onError={(el) => onImageError(el, i)}
                            />
                          )
                        ) : (
                          ""
                        );
                      } else if (imgUrl?.MediaType === "8") {
                        return (
                          <div
                            className="post__document"
                            style={
                              PdfDownloadStatus || PptGeneratingStatus
                                ? {
                                    width: "12.5rem",
                                    height:
                                      el?.EmailContentHtml &&
                                      el?.EmailContentHtml !== "NA"
                                        ? "4rem"
                                        : "8rem",
                                    objectFit: "cover",
                                  }
                                : {
                                    width: "100%",
                                    height:
                                      authParams?.screen_id === "000-000-562"
                                        ? brandPostHeight
                                        : el?.PlatformID === 1
                                        ? "16.3rem"
                                        : "20rem",
                                  }
                            }
                          >
                            <span className="post__document--files">
                              <a
                                href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                                download={imgUrl?.Name}
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => e?.stopPropagation()}
                              >
                                <img
                                  src={pdfIcon}
                                  alt="PDF Document"
                                  style={{
                                    width: "75%",
                                    height: "calc(100% - 5rem)",
                                    objectFit: "contain",
                                  }}
                                />
                                <Tooltip
                                  title={imgUrl?.Name}
                                  placement="bottom"
                                >
                                  <span className="post__document--name text__ellipsis-line2">
                                    {imgUrl?.Name}
                                  </span>
                                </Tooltip>
                              </a>
                            </span>
                          </div>
                        );
                      }
                    })}
                </div>
              ) : el?.Attachment?.length > 1 &&
                !PdfDownloadStatus &&
                !qrChannel &&
                !PptGeneratingStatus ? (
                <div className="w-100" style={{ height: brandPostHeight }}>
                  <CarouselWidgetMaker
                    el={el}
                    // height={
                    //   postText?.length === 0 && el?.PlatformID !== 1
                    //     ? "20rem"
                    //     : "17.4rem"
                    // }
                    deepDive={deepDive}
                    brandPostHeight={brandPostHeight}
                    isDeepDiveDashboardView={isDeepDiveDashboardView}
                  />
                </div>
              ) : (PdfDownloadStatus || PptGeneratingStatus) &&
                el?.Attachment?.length &&
                !qrChannel ? (
                <>
                  <img
                    src={
                      el?.Attachment?.[0]?.ThumbUrl
                        ? el?.Attachment?.[0]?.ThumbUrl
                        : defaultImg
                    }
                    alt="PdfDownloadStatus defualt image"
                    fallback={defaultImg}
                    preview={false}
                    style={{
                      height: el?.PlatformID === 1 ? "16.3rem" : "20rem",
                      objectFit: "cover",
                    }}
                  />
                </>
              ) : (
                ""
              )}

              {/* Mention Text */}
              {el?.Attachment?.length ? (
                <>
                  <PostTextComponent
                    postText={postText}
                    setAutoPlay={setAutoPlay}
                    setIsModalLoader={setIsModalLoader}
                    setIsModalOpen={setIsModalOpen}
                    setIsModalData={setIsModalData}
                    isModalOpen={isModalOpen}
                    trendView={trendView}
                    el={el}
                    dynamicHeight={brandPostMentionTextHeightWithAttachment}
                    highlightWord={highlightWord}
                    isDeepDiveDashboardView={isDeepDiveDashboardView}
                  />
                </>
              ) : (
                <>
                  <PostTextComponent
                    postText={postText}
                    setAutoPlay={setAutoPlay}
                    setIsModalLoader={setIsModalLoader}
                    setIsModalOpen={setIsModalOpen}
                    setIsModalData={setIsModalData}
                    isModalOpen={isModalOpen}
                    trendView={trendView}
                    el={el}
                    dynamicHeight={brandPostMentionTextHeight}
                    highlightWord={highlightWord}
                    isDeepDiveDashboardView={isDeepDiveDashboardView}
                  />
                </>
              )}
            </>
          ) : ((authParams?.screen_id === "000-000-551" ||
              authParams?.screen_id === "000-000-555" ||
              authParams?.screen_id === "000-000-556") &&
              !deepDive &&
              !qrChannel &&
              !trendView &&
              !isDeepDiveDashboardView) ||
            postText?.length > 34 ||
            PdfDownloadStatus ? (
            <>
              <div
                className={`text_regular ${textDirectionClass}`}
                style={{
                  width:
                    commandCenterInfluencersPageId && !isDeepDiveDashboardView
                      ? "100%"
                      : authParams?.screen_id &&
                        !deepDive &&
                        !isDeepDiveDashboardView
                      ? el?.Attachment?.length > 0
                        ? "70%"
                        : "100%"
                      : el?.Attachment?.length > 0 &&
                        !PdfDownloadStatus &&
                        !PptGeneratingStatus
                      ? "50%"
                      : PdfDownloadStatus
                      ? "calc(100% - 9.5rem)"
                      : "",
                }}
              >
                <a
                  className={`${
                    el?.PostURL && el?.PostURL?.trim() && el?.PostURL !== "NA"
                      ? `d-block break-word ${
                          authParams?.screen_id &&
                          !deepDive &&
                          !trendView &&
                          !isDeepDiveDashboardView
                            ? "postCardTextCC"
                            : ""
                        }`
                      : `d-block break-word pointer-events1 cursor-default ${
                          authParams?.screen_id &&
                          !deepDive &&
                          !trendView &&
                          !isDeepDiveDashboardView
                            ? "postCardTextCC"
                            : ""
                        }${needToShowScrollableContent ? "custom_scroll1" : ""}`
                  }`}
                  // href={
                  //   authParams?.screen_id
                  //     ? ""
                  //     : el?.PostURL && el?.PostURL?.trim() && el?.PostURL !== "NA"
                  //     ? el?.PostURL
                  //     : ""
                  // }
                  // target="_blank"
                  // rel="noreferrer"
                  style={{
                    minHeight:
                      commandCenterInfluencersPageId && !isDeepDiveDashboardView
                        ? "auto"
                        : "",
                    maxHeight:
                      authParams?.screen_id &&
                      !deepDive &&
                      !isDeepDiveDashboardView
                        ? "18rem"
                        : authParams?.screen_id === "000-000-555" &&
                          !deepDive &&
                          !trendView &&
                          !isDeepDiveDashboardView
                        ? "max-content"
                        : commandCenterInfluencersPageId &&
                          !deepDive &&
                          !trendView &&
                          !isDeepDiveDashboardView
                        ? "auto"
                        : el?.PlatformID === 1
                        ? "14.7rem"
                        : "17rem",
                    wordBreak:
                      commandCenterInfluencersPageId && !isDeepDiveDashboardView
                        ? "break-word"
                        : "",
                    overflow: "hidden",
                    textDecoration: "none",
                    overflowY: needToShowScrollableContent ? "auto" : "hidden",
                  }}
                >
                  {commandCenterInfluencersPageId && !isDeepDiveDashboardView
                    ? el?.IsMaskedMention &&
                      idPresentFlag &&
                      !isPreviewState &&
                      !PdfDownloadStatus &&
                      !isDashboardScheduleModal &&
                      !PptGeneratingStatus &&
                      authParams?.screen_id
                      ? finalPostText !== ""
                        ? getTextWithWrapHtml(
                            finalPostText,
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                        : getTextWithWrapHtml(
                            postText,
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                      : getTextWithWrapHtml(
                          postText,
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                    : authParams?.screen_id &&
                      !deepDive &&
                      !trendView &&
                      !isDeepDiveDashboardView
                    ? el?.IsMaskedMention &&
                      idPresentFlag &&
                      !isPreviewState &&
                      !isDashboardScheduleModal &&
                      !PdfDownloadStatus &&
                      !PptGeneratingStatus &&
                      authParams?.screen_id
                      ? finalPostText !== ""
                        ? getTextWithWrapHtml(
                            finalPostText?.slice(0, 180),
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                        : getTextWithWrapHtml(
                            postText?.slice(0, 180),
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                      : getTextWithWrapHtml(
                          postText?.slice(0, 180),
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                    : PdfDownloadStatus
                    ? el?.EmailContentHtml && el?.EmailContentHtml !== "NA"
                      ? getTextWithWrapHtml(
                          postText?.slice(0, 50) +
                            (postText?.length > 50 ? "..." : " "),
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                      : postText?.length > 100
                      ? getTextWithWrapHtml(
                          postText?.slice(0, 100) +
                            (postText?.length > 100 ? "..." : " "),
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                      : getTextWithWrapHtml(
                          postText,
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                    : PptGeneratingStatus
                    ? el?.PlatformID === 1 &&
                      postText?.length > 180 &&
                      el?.Attachment?.length > 0
                      ? getTextWithWrapHtml(
                          postText?.slice(0, 180) +
                            (postText?.length > 180 ? "..." : ""),
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                      : el?.PlatformID !== 1 &&
                        postText?.length > 240 &&
                        el?.Attachment?.length > 0
                      ? getTextWithWrapHtml(
                          postText?.slice(0, 240) +
                            (postText?.length > 240 ? "..." : ""),
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                      : postText?.length > 444 && el?.Attachment?.length === 0
                      ? getTextWithWrapHtml(
                          postText?.slice(0, 444) +
                            (postText?.length > 444 ? "..." : ""),
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                      : getTextWithWrapHtml(
                          postText,
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                    : el?.PlatformID === 1 &&
                      postText?.length > 180 &&
                      el?.Attachment?.length > 0
                    ? el?.IsMaskedMention &&
                      idPresentFlag &&
                      !isPreviewState &&
                      !isDashboardScheduleModal &&
                      !PdfDownloadStatus &&
                      !PptGeneratingStatus &&
                      (window.location.pathname?.split("/")?.[1] ===
                        "widgetMaker" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "edit-widget" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "dashboard" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "pin-dashboard" ||
                        authParams?.screen_id)
                      ? finalPostText !== ""
                        ? getTextWithWrapHtml(
                            finalPostText?.slice(0, 180),
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                        : getTextWithWrapHtml(
                            postText?.slice(0, 180),
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                      : getTextWithWrapHtml(
                          postText?.slice(0, 180),
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                    : el?.PlatformID !== 1 &&
                      postText?.length > 240 &&
                      el?.Attachment?.length > 0
                    ? el?.IsMaskedMention &&
                      idPresentFlag &&
                      !isPreviewState &&
                      !PdfDownloadStatus &&
                      !isDashboardScheduleModal &&
                      !PptGeneratingStatus &&
                      (window.location.pathname?.split("/")?.[1] ===
                        "widgetMaker" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "edit-widget" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "dashboard" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "pin-dashboard" ||
                        authParams?.screen_id)
                      ? finalPostText !== ""
                        ? getTextWithWrapHtml(
                            finalPostText?.slice(0, 240),
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                        : getTextWithWrapHtml(
                            postText?.slice(0, 240),
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                      : getTextWithWrapHtml(
                          postText?.slice(0, 240),
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                    : postText?.length > 444 && el?.Attachment?.length === 0
                    ? el?.IsMaskedMention &&
                      idPresentFlag &&
                      !isPreviewState &&
                      !PdfDownloadStatus &&
                      !isDashboardScheduleModal &&
                      !PptGeneratingStatus &&
                      (window.location.pathname?.split("/")?.[1] ===
                        "widgetMaker" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "edit-widget" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "dashboard" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "pin-dashboard" ||
                        authParams?.screen_id)
                      ? finalPostText !== ""
                        ? getTextWithWrapHtml(
                            finalPostText?.slice(0, 444),
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                        : getTextWithWrapHtml(
                            postText?.slice(0, 444),
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                      : getTextWithWrapHtml(
                          postText?.slice(0, 444),
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                    : el?.IsMaskedMention &&
                      idPresentFlag &&
                      !isPreviewState &&
                      !PdfDownloadStatus &&
                      !isDashboardScheduleModal &&
                      !PptGeneratingStatus &&
                      (window.location.pathname?.split("/")?.[1] ===
                        "widgetMaker" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "edit-widget" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "dashboard" ||
                        window.location.pathname?.split("/")?.[1] ===
                          "pin-dashboard" ||
                        authParams?.screen_id)
                    ? finalPostText !== ""
                      ? getTextWithWrapHtml(
                          finalPostText,
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                      : getTextWithWrapHtml(
                          postText,
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )
                    : getTextWithWrapHtml(
                        postText,
                        "",
                        highlightWord,
                        textDirection,
                        needToShowScrollableContent
                      )}
                </a>
                {(commandCenterInfluencersPageId &&
                  !deepDive &&
                  !isDeepDiveDashboardView) ||
                (authParams?.screen_id &&
                  !deepDive &&
                  !trendView &&
                  !isDeepDiveDashboardView &&
                  postText?.length < 180) ? (
                  ""
                ) : ((authParams?.screen_id &&
                    !deepDive &&
                    !trendView &&
                    !isDeepDiveDashboardView &&
                    postText?.length > 180) ||
                    (el?.PlatformID === 1 &&
                      postText?.length > 180 &&
                      el?.Attachment?.length > 0) ||
                    (el?.PlatformID !== 1 &&
                      postText?.length > 240 &&
                      el?.Attachment?.length > 0) ||
                    (postText?.length > 444 && el?.Attachment?.length === 0)) &&
                  !PdfDownloadStatus &&
                  !PptGeneratingStatus ? (
                  <Tooltip
                    title={
                      personalizationSettingsObj?.isPersonalizationPreviewOpen
                        ? "Actions are not allowed while customizing"
                        : ""
                    }
                  >
                    <span
                      className={`blue-text ${
                        personalizationSettingsObj?.isPersonalizationPreviewOpen
                          ? "disabled-cursor"
                          : "cursor-pointer"
                      } ${
                        authParams?.screen_id &&
                        !deepDive &&
                        !trendView &&
                        !isDeepDiveDashboardView
                          ? "postCardReadMoreCC"
                          : ""
                      }`}
                      onClick={() => showModal(el)}
                    >
                      ... Read More
                    </span>
                  </Tooltip>
                ) : (
                  ""
                )}
              </div>
              {el?.Attachment?.length === 1 ? (
                <div
                  className={`${
                    commandCenterInfluencersPageId
                      ? "mb-10 text-center position-relative"
                      : "ml-15 text-center position-relative"
                  } ${
                    authParams?.screen_id === "000-000-556" &&
                    !deepDive &&
                    !trendView &&
                    !isDeepDiveDashboardView
                      ? "cards__imgWrap"
                      : ""
                  }`}
                  style={
                    commandCenterInfluencersPageId && !isDeepDiveDashboardView
                      ? { width: "100%" }
                      : (isCommandCenterScreen || authParams?.screen_id) &&
                        !deepDive &&
                        !trendView &&
                        !isDeepDiveDashboardView
                      ? { width: "30%" }
                      : !PdfDownloadStatus && !PptGeneratingStatus
                      ? { width: "50%" }
                      : { width: "50%" }
                  }
                >
                  {el?.Attachment?.length > 0 &&
                    el?.Attachment.map((imgUrl, index) => {
                      if (
                        imgUrl?.MediaType === "2" ||
                        imgUrl?.MediaType === "4"
                      ) {
                        return imgUrl &&
                          !PdfDownloadStatus &&
                          !PptGeneratingStatus ? (
                          <>
                            <Image
                              src={
                                imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : defaultImg
                              }
                              alt="Preview Group"
                              fallback={defaultImg}
                              preview={
                                authParams?.screen_id === "000-000-555" &&
                                !isDeepDiveDashboardView
                                  ? false
                                  : true
                              }
                              onClick={(e) =>
                                onClickImagePreview(
                                  imgUrl?.ThumbUrl
                                    ? imgUrl?.ThumbUrl
                                    : defaultImg
                                )
                              }
                              style={{
                                height:
                                  (authParams?.screen_id === "000-000-551" ||
                                    authParams?.screen_id === "000-000-556") &&
                                  !deepDive &&
                                  !trendView &&
                                  !isDeepDiveDashboardView
                                    ? "8rem"
                                    : el?.PlatformID === 1
                                    ? "16.3rem"
                                    : "20rem",
                                objectFit: "cover",
                              }}
                              className={
                                authParams?.screen_id === "000-000-555" &&
                                !isDeepDiveDashboardView
                                  ? "three_d_image"
                                  : ""
                              }
                            />
                            {authParams?.screen_id === "000-000-555" &&
                            !isDeepDiveDashboardView ? (
                              <div
                                className="image-perview-div"
                                onClick={(e) =>
                                  onClickImagePreview(
                                    imgUrl?.ThumbUrl
                                      ? imgUrl?.ThumbUrl
                                      : defaultImg
                                  )
                                }
                              >
                                <span>
                                  <img src={EyeWhiteIcon} alt="Perview icon" />
                                </span>
                                Preview
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ) : PdfDownloadStatus || PptGeneratingStatus ? (
                          imgUrl && (
                            <img
                              src={imgUrl?.ThumbUrl}
                              alt="PdfDownloadStatus Attachment Images 1"
                              style={{
                                width: "12.5rem",
                                height:
                                  el?.EmailContentHtml &&
                                  el?.EmailContentHtml !== "NA"
                                    ? "4rem"
                                    : "8rem",
                                objectFit: "cover",
                              }}
                              onError={(el) => onImageError(el, i)}
                            />
                          )
                        ) : (
                          ""
                        );
                      } else if (
                        imgUrl?.MediaType === "3" ||
                        imgUrl?.MediaType === "7"
                      ) {
                        return imgUrl &&
                          !PdfDownloadStatus &&
                          !PptGeneratingStatus ? (
                          <>
                            {el?.PlatformID === 2 ||
                            el?.PlatformID === 4 ||
                            el?.PlatformID === 37 ? (
                              <a
                                href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <div
                                  className="overlay-play-button"
                                  style={{
                                    height:
                                      el?.PlatformID === 1
                                        ? "16.3rem"
                                        : "20rem",
                                  }}
                                >
                                  <img
                                    src={
                                      imgUrl?.ThumbUrl
                                        ? imgUrl?.ThumbUrl
                                        : defaultImg
                                    }
                                    alt="Attachment Images"
                                    onError={(el) => onImageError(el, i)}
                                    style={{
                                      width: "100%",
                                      height: isTrandsView
                                        ? "auto"
                                        : el?.PlatformID === 1
                                        ? "16.3rem"
                                        : "20rem",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div className="overlay-play-button__overlay">
                                    <div className="overlay-play-button__play">
                                      <i
                                        className="fa fa-play"
                                        style={{
                                          fontSize: "1.2rem",
                                          color: "#fff",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            ) : el?.PlatformID === 1 ||
                              el?.PlatformID === 3 ||
                              el?.PlatformID === 5 ||
                              el?.PlatformID === 37 ||
                              el?.PlatformID === 42 ? (
                              <>
                                <div
                                  style={{
                                    height: isTrandsView
                                      ? "auto"
                                      : el?.PlatformID === 1
                                      ? "16.3rem"
                                      : "20rem",
                                  }}
                                  className="overlay-play-button"
                                  onClick={() => handleVideoPreview(imgUrl)}
                                >
                                  <video
                                    width="100%"
                                    style={{
                                      objectFit: "cover",
                                      height: isTrandsView
                                        ? "auto"
                                        : el?.PlatformID === 1
                                        ? "16.3rem"
                                        : "20rem",
                                    }}
                                  >
                                    <source
                                      src={imgUrl?.MediaUrl}
                                      type="video/mp4"
                                    />
                                  </video>

                                  <div className="overlay-play-button__overlay">
                                    <Tooltip
                                      title={
                                        personalizationSettingsObj?.isPersonalizationPreviewOpen
                                          ? "Actions are not allowed while customizing"
                                          : ""
                                      }
                                    >
                                      <div
                                        className={`overlay-play-button__play ${
                                          personalizationSettingsObj?.isPersonalizationPreviewOpen
                                            ? "disabled-cursor"
                                            : ""
                                        }`}
                                      >
                                        <i
                                          className="fa fa-play"
                                          style={{
                                            fontSize: "1.2rem",
                                            color: "#fff",
                                          }}
                                        ></i>
                                      </div>
                                    </Tooltip>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}

                            {/* For Video Preview */}
                            {authParams?.screen_id !== "000-000-555" && (
                              <VideoPreview
                                videoPreview={videoPreview}
                                setIsModalOpen={setIsVideoModalOpen}
                                isModalOpen={isVideoModalOpen}
                                isValidUrlFlag={isValidUrlFlag}
                              />
                            )}
                          </>
                        ) : PdfDownloadStatus || PptGeneratingStatus ? (
                          imgUrl && (
                            <>
                              <img
                                src={imgUrl?.ThumbUrl}
                                alt="PdfDownloadStatus Attachment Images 2"
                                style={{
                                  width: "12.5rem",
                                  height:
                                    el?.EmailContentHtml &&
                                    el?.EmailContentHtml !== "NA"
                                      ? "4rem"
                                      : "8rem",
                                  objectFit: "cover",
                                }}
                                onError={(el) => onImageError(el, i)}
                              />
                              {(imgUrl?.MediaType === "3" ||
                                imgUrl?.MediaType === "7") && (
                                <div className="overlay-play-button__overlay">
                                  <div className="pdf-overlay-play-button__play">
                                    <i
                                      className="fa fa-play"
                                      style={{
                                        fontSize: "1.2rem",
                                        color: "#fff",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              )}
                            </>
                          )
                        ) : (
                          ""
                        );
                      } else if (imgUrl?.MediaType === "8") {
                        return (
                          <div
                            className="post__document"
                            style={
                              PdfDownloadStatus || PptGeneratingStatus
                                ? {
                                    width: "12.5rem",
                                    height:
                                      el?.EmailContentHtml &&
                                      el?.EmailContentHtml !== "NA"
                                        ? "4rem"
                                        : "8rem",
                                    objectFit: "cover",
                                  }
                                : {
                                    width: "100%",
                                    height:
                                      el?.PlatformID === 1
                                        ? "16.3rem"
                                        : "20rem",
                                  }
                            }
                          >
                            <span className="post__document--files">
                              <a
                                href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                                download={imgUrl?.Name}
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => e?.stopPropagation()}
                              >
                                <img
                                  src={pdfIcon}
                                  alt="PDF Document"
                                  style={{
                                    width: "75%",
                                    height: "calc(100% - 5rem)",
                                    objectFit: "contain",
                                  }}
                                />
                                <Tooltip
                                  title={imgUrl?.Name}
                                  placement="bottom"
                                >
                                  <span className="post__document--name text__ellipsis-line2">
                                    {imgUrl?.Name}
                                  </span>
                                </Tooltip>
                              </a>
                            </span>
                          </div>
                        );
                      }
                    })}
                </div>
              ) : el?.Attachment?.length > 1 &&
                !PdfDownloadStatus &&
                !PptGeneratingStatus ? (
                <div
                  className={` ${
                    commandCenterInfluencersPageId ? "mb-10" : "ml-15"
                  } text-center ${
                    authParams?.screen_id !== "000-000-553" &&
                    authParams?.screen_id &&
                    !deepDive &&
                    !trendView &&
                    !isDeepDiveDashboardView
                      ? "carousel__wrapper"
                      : ""
                  }`}
                  style={{
                    width: commandCenterInfluencersPageId
                      ? "100%"
                      : authParams?.screen_id &&
                        !deepDive &&
                        !trendView &&
                        !isDeepDiveDashboardView
                      ? "30%"
                      : "50%",
                  }}
                >
                  <CarouselWidgetMaker
                    el={el}
                    height={el?.PlatformID === 1 ? "16.3rem" : "20rem"}
                    deepDive={deepDive}
                    isDeepDiveDashboardView={isDeepDiveDashboardView}
                  />
                </div>
              ) : (PdfDownloadStatus || PptGeneratingStatus) &&
                el?.Attachment?.length ? (
                <>
                  <img
                    src={
                      el?.Attachment?.[0]?.ThumbUrl
                        ? el?.Attachment?.[0]?.ThumbUrl
                        : defaultImg
                    }
                    alt="PdfDownloadStatus defualt image"
                    fallback={defaultImg}
                    preview={false}
                    style={{
                      width: "12.5rem",
                      height:
                        el?.EmailContentHtml && el?.EmailContentHtml !== "NA"
                          ? "4rem"
                          : "8rem",
                      objectFit: "cover",
                    }}
                  />
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              {postText && !qrChannel && (
                <div
                  className={`text_regular break-word mb-1 ${textDirectionClass}`}
                >
                  <a
                    // className={
                    //   el?.PostURL && el?.PostURL?.trim() && el?.PostURL !== "NA"
                    //     ? ""
                    //     : "pointer-events1 cursor-default"
                    // }
                    className={`${
                      el?.PostURL && el?.PostURL?.trim() && el?.PostURL !== "NA"
                        ? `pointer-events1 cursor-default ${
                            authParams?.screen_id &&
                            !deepDive &&
                            !trendView &&
                            !isDeepDiveDashboardView
                              ? "postCardTextCC"
                              : ""
                          }`
                        : `pointer-events1 cursor-default ${
                            authParams?.screen_id &&
                            !deepDive &&
                            !trendView &&
                            !isDeepDiveDashboardView
                              ? "postCardTextCC"
                              : ""
                          }`
                    }`}
                    style={{
                      textDecoration: "none",
                    }}
                    // href={
                    //   authParams?.screen_id
                    //     ? ""
                    //     : el?.PostURL && el?.PostURL?.trim() && el?.PostURL !== "NA"
                    //     ? el?.PostURL
                    //     : ""
                    // }
                    // target="_blank"
                    // rel="noreferrer"
                  >
                    {el?.IsMaskedMention &&
                    idPresentFlag &&
                    !isPreviewState &&
                    !PdfDownloadStatus &&
                    !isDashboardScheduleModal &&
                    !PptGeneratingStatus &&
                    (window.location.pathname?.split("/")?.[1] ===
                      "widgetMaker" ||
                      window.location.pathname?.split("/")?.[1] ===
                        "edit-widget" ||
                      window.location.pathname?.split("/")?.[1] ===
                        "dashboard" ||
                      window.location.pathname?.split("/")?.[1] ===
                        "pin-dashboard" ||
                      authParams?.screen_id)
                      ? finalPostText !== ""
                        ? getTextWithWrapHtml(
                            finalPostText,
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                        : getTextWithWrapHtml(
                            postText,
                            "",
                            highlightWord,
                            textDirection,
                            needToShowScrollableContent
                          )
                      : getTextWithWrapHtml(
                          postText,
                          "",
                          highlightWord,
                          textDirection,
                          needToShowScrollableContent
                        )}
                  </a>
                </div>
              )}
              {el?.Attachment?.length === 1 ? (
                <div
                  className={
                    commandCenterInfluencersPageId
                      ? "mb-10 w-100 text-center position-relative attachment_image"
                      : "m-0 w-100 text-center position-relative attachment_image"
                  }
                >
                  {el?.Attachment?.length > 0 &&
                    el?.Attachment?.map((imgUrl, index) => {
                      if (
                        imgUrl?.MediaType === "2" ||
                        imgUrl?.MediaType === "4"
                      ) {
                        return imgUrl &&
                          !PdfDownloadStatus &&
                          !PptGeneratingStatus ? (
                          <>
                            <Image
                              src={
                                imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : defaultImg
                              }
                              alt="Preview Group"
                              fallback={defaultImg}
                              preview={
                                authParams?.screen_id === "000-000-555" &&
                                !isDeepDiveDashboardView
                                  ? false
                                  : true
                              }
                              style={{
                                height:
                                  el?.PlatformID === 1 ? "16.3rem" : "20rem",
                                objectFit: "cover",
                              }}
                            />
                          </>
                        ) : PdfDownloadStatus || PptGeneratingStatus ? (
                          imgUrl && (
                            <img
                              src={imgUrl?.ThumbUrl}
                              alt="PdfDownloadStatus Attachment Images 3"
                              style={{
                                height:
                                  el?.PlatformID === 1 ? "16.3rem" : "20rem",
                                objectFit: "cover",
                              }}
                              onError={(el) => onImageError(el, i)}
                            />
                          )
                        ) : (
                          ""
                        );
                      } else if (
                        imgUrl?.MediaType === "3" ||
                        imgUrl?.MediaType === "7"
                      ) {
                        return imgUrl &&
                          !PdfDownloadStatus &&
                          !PptGeneratingStatus ? (
                          <>
                            {el?.PlatformID === 2 ||
                            el?.PlatformID === 4 ||
                            el?.PlatformID === 37 ? (
                              <a
                                href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <div
                                  className="overlay-play-button"
                                  style={{
                                    height:
                                      el?.PlatformID === 1
                                        ? "16.3rem"
                                        : "20rem",
                                  }}
                                >
                                  <img
                                    src={
                                      imgUrl?.ThumbUrl
                                        ? imgUrl?.ThumbUrl
                                        : defaultImg
                                    }
                                    alt="Attachment Images"
                                    onError={(el) => onImageError(el, i)}
                                    style={{
                                      width: "100%",
                                      height:
                                        el?.PlatformID === 1
                                          ? "16.3rem"
                                          : "20rem",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div className="overlay-play-button__overlay">
                                    <div className="overlay-play-button__play">
                                      <i
                                        className="fa fa-play"
                                        style={{
                                          fontSize: "1.2rem",
                                          color: "#fff",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            ) : el?.PlatformID === 1 ||
                              el?.PlatformID === 3 ||
                              el?.PlatformID === 5 ||
                              el?.PlatformID === 37 ||
                              el?.PlatformID === 42 ? (
                              <>
                                <div
                                  style={{
                                    height:
                                      el?.PlatformID === 1
                                        ? "16.3rem"
                                        : "20rem",
                                  }}
                                  className="overlay-play-button"
                                  onClick={() => handleVideoPreview(imgUrl)}
                                >
                                  <video
                                    width="100%"
                                    style={{
                                      objectFit: "cover",
                                      height:
                                        el?.PlatformID === 1
                                          ? "16.3rem"
                                          : "20rem",
                                    }}
                                  >
                                    <source
                                      src={imgUrl?.MediaUrl}
                                      type="video/mp4"
                                    />
                                  </video>
                                  <div className="overlay-play-button__overlay">
                                    <div className="overlay-play-button__play">
                                      <i
                                        className="fa fa-play"
                                        style={{
                                          fontSize: "1.2rem",
                                          color: "#fff",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}

                            {/* For Video Preview */}
                            <VideoPreview
                              videoPreview={videoPreview}
                              setIsModalOpen={setIsVideoModalOpen}
                              isModalOpen={isVideoModalOpen}
                              isValidUrlFlag={isValidUrlFlag}
                              isDeepDiveDashboardView={isDeepDiveDashboardView}
                            />
                          </>
                        ) : PdfDownloadStatus || PptGeneratingStatus ? (
                          imgUrl && (
                            <img
                              src={imgUrl?.ThumbUrl}
                              alt="PdfDownloadStatus Attachment Images 4"
                              style={{
                                height:
                                  el?.PlatformID === 1 ? "16.3rem" : "20rem",
                                objectFit: "cover",
                              }}
                              onError={(el) => onImageError(el, i)}
                            />
                          )
                        ) : (
                          ""
                        );
                      } else if (imgUrl?.MediaType === "8") {
                        return (
                          <div
                            className="post__document"
                            style={
                              PdfDownloadStatus || PptGeneratingStatus
                                ? {
                                    width: "12.5rem",
                                    height:
                                      el?.EmailContentHtml &&
                                      el?.EmailContentHtml !== "NA"
                                        ? "4rem"
                                        : "8rem",
                                    objectFit: "cover",
                                  }
                                : {
                                    width: "100%",
                                    height:
                                      authParams?.screen_id === "000-000-562" &&
                                      !isDeepDiveDashboardView
                                        ? brandPostHeight
                                        : el?.PlatformID === 1
                                        ? "16.3rem"
                                        : "20rem",
                                  }
                            }
                          >
                            <span className="post__document--files">
                              <a
                                href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                                download={imgUrl?.Name}
                                target="_blank"
                                rel="noreferrer"
                                onClick={(e) => e?.stopPropagation()}
                              >
                                <img
                                  src={pdfIcon}
                                  alt="PDF Document"
                                  style={{
                                    width: "75%",
                                    height: "calc(100% - 5rem)",
                                    objectFit: "contain",
                                  }}
                                />
                                <Tooltip
                                  title={imgUrl?.Name}
                                  placement="bottom"
                                >
                                  <span className="post__document--name text__ellipsis-line2">
                                    {imgUrl?.Name}
                                  </span>
                                </Tooltip>
                              </a>
                            </span>
                          </div>
                        );
                      }
                    })}
                </div>
              ) : el?.Attachment?.length > 1 &&
                !PdfDownloadStatus &&
                !PptGeneratingStatus ? (
                <div className="w-100">
                  <CarouselWidgetMaker
                    el={el}
                    height={
                      postText?.length === 0 && el?.PlatformID !== 1
                        ? "20rem"
                        : "17.4rem"
                    }
                    deepDive={deepDive}
                    isDeepDiveDashboardView={isDeepDiveDashboardView}
                  />
                </div>
              ) : (PdfDownloadStatus || PptGeneratingStatus) &&
                el?.Attachment?.length ? (
                <>
                  <img
                    src={
                      el?.Attachment?.[0]?.ThumbUrl
                        ? el?.Attachment?.[0]?.ThumbUrl
                        : defaultImg
                    }
                    alt="PdfDownloadStatus defualt image"
                    fallback={defaultImg}
                    preview={false}
                    style={{
                      height: el?.PlatformID === 1 ? "16.3rem" : "20rem",
                      objectFit: "cover",
                    }}
                  />
                </>
              ) : (
                ""
              )}
            </>
          )}
          {commandCenterInfluencersPageId &&
          el?.isMenstionCountBlock &&
          !qrChannel ? (
            <div
              className={`d-flex menstion-content-text align-items-center justify-content-center ${
                isNewData ? "updated-mention-count" : ""
              }`}
            >
              {el?.value?.toLocaleString()}
            </div>
          ) : (
            ""
          )}

          {pollData && pollData?.options?.length ? (
            <>
              {pollData?.options?.map((poll) => {
                return (
                  <div style={{ width: "100%" }}>
                    <p className="text_regular">{poll?.text}</p>
                    <div className="d-flex" style={{ marginTop: "-2rem" }}>
                      <span style={{ width: "80%", marginRight: "2rem" }}>
                        <Progress percent={poll?.vote_percent} />
                      </span>
                      <span
                        style={{
                          width: "20%",
                          alignSelf: "center",
                        }}
                        className="text_regular"
                      >
                        ({poll?.vote_count})
                      </span>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            ""
          )}

          {authParams?.screen_id === "000-000-555" &&
            !isDeepDiveDashboardView &&
            closeImagePreview &&
            !qrChannel && (
              <div className="image-perview-modal">
                <Modal
                  title=""
                  open={closeImagePreview}
                  className="image-perview-modal"
                  footer={null}
                  onCancel={handleCloseImagePerview}
                  closable={false}
                >
                  <Image src={previewImgUrl} preview={false} />
                </Modal>
              </div>
            )}
          {authParams?.screen_id === "000-000-555" &&
            !isDeepDiveDashboardView &&
            isVideoModalOpen &&
            !qrChannel && (
              <div className="image-perview-modal">
                <Modal
                  title=""
                  open={isVideoModalOpen}
                  className="image-perview-modal"
                  footer={null}
                  onCancel={handleCloseImagePerview}
                  closable={false}
                >
                  <VideoPreview
                    videoPreview={videoPreview}
                    setIsModalOpen={handleCloseVideoModalClose}
                    isModalOpen={isVideoModalOpen}
                    isValidUrlFlag={isValidUrlFlag}
                  />
                </Modal>
              </div>
            )}
        </>
      )}
      {qrChannel ? (
        <div
          className="m-0 w-100 h-100 d-flex flex-wrap position-relative"
          ref={surveyFieldContainer}
        >
          {Array.isArray(el?.SurveySubmitJson) &&
            el?.SurveySubmitJson?.map((d, i) => {
              return (
                <>
                  {d?.ratingType &&
                  ["star", "emoji", "nps"]?.includes(d?.ratingType) ? (
                    <div className="w-100">
                      <div className="mb-1 text_heading fontSize-12 font-weight600 surevyCard--title">
                        {getTextWithWrapHtml(d?.labelname, "", highlightWord)}
                      </div>
                      <div className="d-flex align-items-center justify-content-center w-100 mb-1">
                        {d?.ratingType &&
                        ["star", "emoji", "nps"]?.includes(d?.ratingType) ? (
                          <>
                            <div className="rating-builder">
                              {d?.ratingType === "star" ? (
                                <Rate
                                  disabled
                                  value={d?.value}
                                  className="no--wrap w-100 ratingList mr-1"
                                  style={{
                                    fontSize: "3.2rem",
                                  }}
                                />
                              ) : d?.ratingType === "emoji" ? (
                                <div className="rating-builder__wrapper">
                                  <img
                                    src={smilingFaceWithHeartEyes}
                                    alt=""
                                    className={`${
                                      parseInt(d?.value) === 5
                                        ? "emoji-selected emoji-hover"
                                        : "filter-grey"
                                    }`}
                                    style={{
                                      width:
                                        parseInt(d?.value) === 5
                                          ? "4rem"
                                          : "3.2rem",
                                      minWidth:
                                        parseInt(d?.value) === 5
                                          ? "4rem"
                                          : "3.2rem",
                                      maxWidth:
                                        parseInt(d?.value) === 5
                                          ? "4rem"
                                          : "3.2rem",
                                    }}
                                  />
                                  <img
                                    src={smilingFaceWithSmilingEyes}
                                    alt=""
                                    className={`${
                                      parseInt(d?.value) === 4
                                        ? "emoji-selected emoji-hover"
                                        : "filter-grey"
                                    }`}
                                    style={{
                                      width:
                                        parseInt(d?.value) === 4
                                          ? "4rem"
                                          : "3.2rem",
                                      minWidth:
                                        parseInt(d?.value) === 4
                                          ? "4rem"
                                          : "3.2rem",
                                      maxWidth:
                                        parseInt(d?.value) === 4
                                          ? "4rem"
                                          : "3.2rem",
                                    }}
                                  />
                                  <img
                                    src={neutralFace}
                                    alt=""
                                    className={`${
                                      parseInt(d?.value) === 3
                                        ? "emoji-selected emoji-hover"
                                        : "filter-grey"
                                    }`}
                                    style={{
                                      width:
                                        parseInt(d?.value) === 3
                                          ? "4rem"
                                          : "3.2rem",
                                      minWidth:
                                        parseInt(d?.value) === 3
                                          ? "4rem"
                                          : "3.2rem",
                                      maxWidth:
                                        parseInt(d?.value) === 3
                                          ? "4rem"
                                          : "3.2rem",
                                    }}
                                  />
                                  <img
                                    src={frowningFace}
                                    alt=""
                                    className={`${
                                      parseInt(d?.value) === 2
                                        ? "emoji-selected emoji-hover"
                                        : "filter-grey"
                                    }`}
                                    style={{
                                      width:
                                        parseInt(d?.value) === 2
                                          ? "4rem"
                                          : "3.2rem",
                                      minWidth:
                                        parseInt(d?.value) === 2
                                          ? "4rem"
                                          : "3.2rem",
                                      maxWidth:
                                        parseInt(d?.value) === 2
                                          ? "4rem"
                                          : "3.2rem",
                                    }}
                                  />

                                  <img
                                    src={tiredEmoji}
                                    alt=""
                                    className={`${
                                      parseInt(d?.value) === 1
                                        ? "emoji-selected emoji-hover"
                                        : "filter-grey"
                                    }`}
                                    style={{
                                      width:
                                        parseInt(d?.value) === 1
                                          ? "4rem"
                                          : "3.2rem",
                                      minWidth:
                                        parseInt(d?.value) === 1
                                          ? "4rem"
                                          : "3.2rem",
                                      maxWidth:
                                        parseInt(d?.value) === 1
                                          ? "4rem"
                                          : "3.2rem",
                                    }}
                                  />
                                </div>
                              ) : d?.ratingType === "nps" ? (
                                <div className="rating-builder__wrapper">
                                  <ul className="rating-builder__nps cursor-pointer p-0 mb-1">
                                    {Array.isArray(NPS_OPTIONS) &&
                                      NPS_OPTIONS?.map((n) => {
                                        return (
                                          <li
                                            className={`list ${
                                              n > 7
                                                ? "bg__green"
                                                : n == 6 || n == 7
                                                ? "bg__yellow--dark"
                                                : n < 6
                                                ? "bg__red--dark"
                                                : ""
                                            } ${
                                              parseInt(d?.value) === n
                                                ? "select-nps"
                                                : "unselect-nps"
                                            }`}
                                          >
                                            {n}
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </>
                        ) : (
                          <span className="pre--wrap text-grayLight surevyCard--value">
                            {getTextWithWrapHtml(d?.value, "", highlightWord)}
                          </span>
                        )}

                        {/* {typeof d?.value === "number" ? (
                      <Rate
                        disabled
                        value={d?.value}
                        className="no--wrap w-100 ratingList mr-1"
                      />
                    ) : (
                      <span className="pre--wrap text-grayLight">{d?.value}</span>
                    )} */}
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`d-flex align-items-center mb-1 ${
                        Number(d?.fieldType) === ElementTypeEnum?.textarea
                          ? "w-100"
                          : ""
                      }`}
                    >
                      {/* <span className="mr-3 text_heading fontSize-12 font-weight600 surevyCard--title">
                        {d?.labelname}
                      </span>
                      <span className="d-flex align-items-center">
                        <span className="pre--wrap text-grayLight surevyCard--value">
                          {d?.value}
                        </span>
                      </span> */}
                      <span className="mr-2 pre--wrap text-grayLight surevyCard--value ">
                        <span className="mr-1 text_heading fontSize-12 font-weight600 surevyCard--title">
                          {getTextWithWrapHtml(d?.labelname, "", highlightWord)}
                        </span>{" "}
                        {getTextWithWrapHtml(d?.value, "", highlightWord)}
                      </span>
                    </div>
                  )}
                </>
              );
            })}
          {isSurveyFieldsAreOverflowed ? (
            <span
              className="blue-text cursor-pointer SurveyCard--readmore pb-1"
              onClick={() => showModal(el)}
            >
              ... Read More
            </span>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
      <PostCardDetails
        data={data}
        modalData={modalData}
        isPreviewState={isPreviewState}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        setIsModalData={setIsModalData}
        isModalLoader={isModalLoader}
        setIsModalLoader={setIsModalLoader}
        isCommandCenterScreen={isCommandCenterScreen}
        el={el}
        custom_card_settings={custom_card_settings}
        deepDive={deepDive}
        setAutoPlay={setAutoPlay}
        trendView={trendView}
        qrChannel={qrChannel}
        pantipChannel={pantipChannel}
        section_index={section_index}
        widget_index={widget_index}
        highlightWord={highlightWord}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      />
    </div>
  );
};

export default PostAttachment;
